<div class="content">
  <nz-collapse [nzBordered]="false">
    <nz-collapse-panel [nzHeader]="'FILTERS' | translate" [nzActive]="isActiveFilters">
      <form
        *ngIf="formReady"
        nz-form
        [formGroup]="form"
        (ngSubmit)="filter(form.value)"
        [nzLayout]="'vertical'"
      >
        <nz-row [nzGutter]="40">
          <div class="week">
            <nz-tag
              *ngFor="let date of dateRange"
              [nzMode]="'checkable'"
              [nzChecked]="date.checked"
              (nzCheckedChange)="selectDateAuction($event, date)"
            >
              {{ getDate(date.date) | date: 'EEE' | translate }}
            </nz-tag>
          </div>
        </nz-row>
        <nz-row [nzGutter]="40">
          <nz-col [nzXs]="24" [nzMd]="8" [nzXl]="6">
            <nz-form-item>
              <nz-form-label>
                <strong>{{ 'COMPANY' | translate }}</strong>
              </nz-form-label>
              <nz-form-control>
                <nz-select
                  formControlName="company"
                  nzShowSearch
                  nzAllowClear
                  (ngModelChange)="change($event)"
                  [nzPlaceHolder]="'SELECT_COMPANY' | translate"
                >
                  <nz-option
                    *ngFor="let company of companiesList"
                    [nzValue]="company.companyId"
                    [nzLabel]="company.name"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>
                <strong>{{ 'MODEL' | translate }}</strong>
              </nz-form-label>
              <nz-form-control>
                <nz-select
                  nzAllowClear
                  formControlName="model"
                  nzShowSearch
                  [nzPlaceHolder]="'SELECT_MODEL' | translate"
                  (ngModelChange)="change($event)"
                  [nzDisabled]="!form.controls.company.value"
                >
                  <nz-option
                    *ngFor="let motoModel of companies[form.controls.company.value]?.motoModels"
                    [nzValue]="motoModel.modelId"
                    nzLabel="{{ motoModel.name }} ({{ motoModel.motoLotsTotal }})"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>
                <strong>{{ 'LOT_INFO.AUCTION' | translate }}</strong>
              </nz-form-label>
              <nz-form-control>
                <nz-select
                  formControlName="auction"
                  nzAllowClear
                  [nzPlaceHolder]="'SELECT_AUCTION' | translate"
                >
                  <nz-option [nzLabel]="'ALL' | translate" nzValue="all"></nz-option>
                  <nz-option
                    *ngFor="let auction of auctions"
                    [nzLabel]="auction.motoAuction.name"
                    [nzValue]="auction.auctRef"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox formControlName="datetime">
                  <strong>{{ 'AUCTION_NOT_STARTED' | translate }}</strong>
                </label>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col [nzXs]="24" [nzMd]="8" [nzXl]="6">
            <nz-form-item>
              <nz-form-label class="label-flex">
                <strong>{{ 'LOT_INFO.YEAR' | translate }}</strong>
                <span
                  *ngIf="isYearFiltered"
                  (click)="removeFilter('year')"
                  nz-text
                  nzType="secondary"
                  >{{ 'SEE_ALL' | translate }}</span
                >
              </nz-form-label>
              <nz-form-control>
                <nz-input-group nzCompact class="moto-year-selectors">
                  <input
                    class="from"
                    nz-input
                    type="number"
                    formControlName="yearFrom"
                    (change)="change($event)"
                    [placeholder]="'FROM' | translate"
                  />
                  <input class="input-divider" type="text" disabled nz-input placeholder="-" />
                  <input
                    class="to"
                    nz-input
                    type="number"
                    formControlName="yearTo"
                    [placeholder]="'TO' | translate"
                    (change)="change($event)"
                  />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>
                <strong>{{ 'LOT_INFO.MILEAGE' | translate }}</strong>
                <span
                  *ngIf="isMileageFiltered"
                  (click)="removeFilter('mileage')"
                  nz-text
                  [nzType]="'secondary'"
                  >{{ 'SEE_ALL' | translate }}</span
                >
              </nz-form-label>
              <nz-form-control>
                <nz-input-group nzCompact class="moto-mileage-selectors">
                  <input
                    class="from"
                    nz-input
                    type="number"
                    formControlName="mileageFrom"
                    (change)="change($event)"
                    [placeholder]="'FROM' | translate"
                  />
                  <input class="input-divider" type="text" disabled nz-input placeholder="-" />
                  <input
                    class="to"
                    nz-input
                    type="number"
                    formControlName="mileageTo"
                    [placeholder]="'TO' | translate"
                    (change)="change($event)"
                  />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>
                <strong>{{ 'ENGINE_VOLUME' | translate }}</strong>
                <span
                  *ngIf="isEngineVolumeFiltered"
                  (click)="removeFilter('engineVolume')"
                  nz-text
                  [nzType]="'secondary'"
                  >{{ 'SEE_ALL' | translate }}</span
                >
              </nz-form-label>
              <nz-form-control>
                <nz-input-group nzCompact class="moto-engine-volume-selectors">
                  <input
                    class="from"
                    type="number"
                    nz-input
                    formControlName="engineVolumeFrom"
                    (change)="change($event)"
                    [placeholder]="'FROM' | translate"
                  />
                  <input class="input-divider" type="text" disabled nz-input placeholder="-" />
                  <input
                    class="to"
                    type="number"
                    nz-input
                    formControlName="engineVolumeTo"
                    [placeholder]="'TO' | translate"
                    (change)="change($event)"
                  />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col [nzXs]="24" [nzMd]="8" [nzXl]="6">
            <nz-form-item>
              <nz-form-label>
                <strong>{{ 'SEARCH_BY_BID' | translate }}</strong>
              </nz-form-label>
              <nz-form-control>
                <input
                  type="text"
                  formControlName="bid"
                  nz-input
                  [placeholder]="'INPUT_BID_NUMBER' | translate"
                />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>
                <strong>{{ 'LOT_INFO.SCORE' | translate }}</strong>
              </nz-form-label>
              <nz-form-control>
                <nz-select
                  formControlName="inclusionScore"
                  nzAllowClear
                  [nzMode]="'multiple'"
                  [nzPlaceHolder]="'SCORE_SELECT' | translate"
                  [nzDisabled]="!data.scoresEnOptions"
                >
                  <nz-option
                    *ngFor="let score of data.scoresEnOptions"
                    [nzLabel]="score.scoresEn"
                    [nzValue]="score.scoresEn"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>
                <strong>{{ 'LOT_INFO.COLOR' | translate }}</strong>
              </nz-form-label>
              <nz-form-control>
                <nz-select
                  formControlName="inclusionColor"
                  nzAllowClear
                  [nzMode]="'multiple'"
                  [nzPlaceHolder]="'COLOR_SELECT' | translate"
                  [nzDisabled]="!data.colorEnOptions"
                >
                  <nz-option
                    *ngFor="let option of data.colorEnOptions"
                    [nzLabel]="option.colorEn"
                    [nzValue]="option.colorEn"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
        </nz-row>

        <nz-row
          [nzGutter]="40"
          *akbCheck="['world.akebono.auto.auctioneer', 'world.akebono.auto.translator']"
        >
          <nz-col [nzSpan]="24" [nzMd]="8" [nzXl]="6" class="search-area">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox formControlName="hasBids">
                  <strong>{{ 'HAS_BID' | translate }}</strong>
                </label>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col [nzSpan]="24" [nzMd]="8" [nzXl]="6" class="search-area">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox formControlName="hasNegotiations">
                  <strong>{{ 'HAS_NEGOTIATIONS' | translate }}</strong>
                </label>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col [nzSpan]="24" [nzMd]="8" [nzXl]="6" class="search-area">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox formControlName="hasTranslations">
                  <strong>{{ 'HAS_TRANSLATIONS' | translate }}</strong>
                </label>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
        </nz-row>

        <nz-row>
          <nz-col [nzSpan]="24" class="search-area">
            <button nz-button nzType="primary" (click)="scrollToTable()">
              {{ 'SEARCH' | translate }}
            </button>
            <button nz-button (click)="resetFilter()">{{ 'CLEAR' | translate }}</button>
          </nz-col>
        </nz-row>
      </form>
    </nz-collapse-panel>
  </nz-collapse>

  <nz-divider></nz-divider>

  <nz-row nzJustify="center" class="purchase-statistics">
    <app-user-purchase-statistics></app-user-purchase-statistics>
  </nz-row>

  <nz-table
    #table
    class="table"
    nzTitle="{{ 'TOTAL' | translate }}: {{ data.total }}"
    [nzTotal]="data.total"
    [nzData]="data.nodes"
    [nzPageIndex]="page"
    [nzPageSize]="pageSize"
    [nzLoading]="loading"
    [nzFrontPagination]="false"
    [nzBordered]="true"
    [nzPaginationPosition]="'both'"
    (nzPageIndexChange)="changePage($event)"
    (nzPageSizeChange)="changePageSize($event)"
    nzShowSizeChanger
  >
    <thead>
      <tr>
        <th nzAlign="center">{{ 'PHOTO' | translate }}</th>
        <th nzAlign="center">
          <app-sort-component
            (nzSortChange)="sortEvent($event)"
            [sortKey]="'bid'"
            [title]="'LOT' | translate"
          ></app-sort-component>
        </th>
        <th nzAlign="center">
          <app-sort-component
            (nzSortChange)="sortEvent($event)"
            [sortKey]="'auctionRef'"
            [title]="'LOT_INFO.AUCTION' | translate"
          ></app-sort-component>
          /
          <app-sort-component
            (nzSortChange)="sortEvent($event)"
            [sortKey]="'date'"
            [title]="'DATE' | translate"
          ></app-sort-component>
        </th>
        <th nzAlign="center">
          <app-sort-component
            (nzSortChange)="sortEvent($event)"
            [sortKey]="'modelYearEn'"
            [title]="'LOT_INFO.YEAR' | translate"
          ></app-sort-component>
        </th>
        <th nzAlign="center" [ngClass]="'hide-column-small'">
          <app-sort-component
            (nzSortChange)="sortEvent($event)"
            [sortKey]="'displacementNum'"
            [title]="'LOT_INFO.ENGINE_CC' | translate"
          ></app-sort-component>
        </th>
        <th nzAlign="center" [ngClass]="'hide-column-small'">
          <app-sort-component
            (nzSortChange)="sortEvent($event)"
            [sortKey]="'mileageNum'"
            [title]="'LOT_INFO.MILEAGE' | translate"
          ></app-sort-component>
          /
          <app-sort-component
            (nzSortChange)="sortEvent($event)"
            [sortKey]="'scoresEn'"
            [title]="'LOT_INFO.SCORE' | translate"
          ></app-sort-component>
        </th>
        <th nzAlign="center">
          <app-sort-component
            (nzSortChange)="sortEvent($event)"
            [sortKey]="'startPriceNum'"
            [title]="'LOT_INFO.START_PRICE' | translate"
          ></app-sort-component>
          /
          <app-sort-component
            (nzSortChange)="sortEvent($event)"
            [sortKey]="'endPriceNum'"
            [title]="'LOT_INFO.SOLD_FOR' | translate"
          ></app-sort-component>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of table.data">
        <td nzAlign="center">
          <app-lot-mini-gallery [lot]="item"></app-lot-mini-gallery>
        </td>
        <td nzAlign="center">
          {{ item.companyEn }} {{ item.modelNameEn }}<br />
          <ng-container *ngIf="lotListData$ | async as lotListData">
            <app-lots-list-lot-link
              [lot]="item"
              [lotType]="LotTypeEnum.Moto"
              [lotSource]="LotSource.Aleado"
              link="/moto/lot/{{ item.id }}"
              [lotData]="lotListData?.get(item.id)"
            ></app-lots-list-lot-link>
          </ng-container>
        </td>
        <td nzAlign="center">
          <app-lot-auction-name [auctionName]="item.motoAuction.name"></app-lot-auction-name>
          <br />
          {{ item.time | date: 'yyyy-MM-dd H:mm:ss zz':'+0900' }}
        </td>
        <td nzAlign="left">
          <span nz-text nzType="danger">{{ item.year }}</span> <br *ngIf="item.year" />
          <span nz-text nzType="secondary">{{ item.frame }} {{ item.modelGrade }}</span>
        </td>
        <td nzAlign="left" [ngClass]="'hide-column-small'">
          {{ item.engineVolume }} cc<br />
          <span nz-text nzType="secondary">{{ item.colorEn }}</span>
        </td>
        <td nzAlign="right" [ngClass]="'hide-column-small'">
          {{ item.mileage }}
          <span nz-text nzType="warning">{{ item.rate }}</span>
        </td>
        <td nzAlign="right">
          {{ item.startPrice | currency: 'JPY':'symbol-narrow' }}
          <br />
          <ng-container *ngIf="lotListData$ | async as lotListData">
            {{
              lotListData.get(item.id)?.soldPrice || item.finishPrice
                | currency: 'JPY':'symbol-narrow'
            }}
          </ng-container>
          <nz-tag *ngIf="item.result" class="m-0">
            {{ item.result | translate }}
          </nz-tag>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
